import React, { FC } from "react";

import { useTranslation } from "react-i18next";

import { formatOdds, formatProbability, formatTipName } from "@utils";

import { TeamsHeader } from "@ui/components";
import { Box, Tag, Text, Title } from "@ui/elements";
import { Stack } from "@ui/layout";

import { formatTipCategory } from "../../utils/formatTipCategory";

import "./TopPickBox.scss";

export const TopPickBoxSkeleton: FC = () => {
  const { t } = useTranslation();

  return (
    <Box>
      <Stack direction="column">
        <Stack
          direction="row"
          justify="between"
          className="top-pick-box-header"
          align="center"
        >
          <Stack align="center">
            <Tag isLoading variant="light">
              {t(`rating.safe`)}
            </Tag>
          </Stack>
        </Stack>
        <div className="teams-header-wrapper">
          <TeamsHeader title="Home Team vs Away Team" isLoading />
        </div>

        <Stack justify="between" className="tip-recommendation-box">
          <Stack direction="column" gap="xxs">
            <Text isLoading variant="secondary">
              {formatTipCategory("Match Winner")}
            </Text>
            <Title size={5} isLoading>
              {formatTipName("Match Winner", "Home")}
            </Title>
          </Stack>

          <Stack direction="column" gap="xxs" justify="end">
            <Text variant="secondary" align="right" isLoading>
              {t("odds")}
            </Text>
            <Title size={5} align="right" isLoading>
              {formatOdds("1.24")}
            </Title>
          </Stack>
        </Stack>

        <Stack direction="column" align="start" gap="xxs">
          <Text
            variant="secondary"
            className="top-pick-reasoning line-clamp-2"
            isLoading
          >
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do
            eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim
          </Text>
        </Stack>

        <Stack justify="between">
          <Text isLoading>
            <strong>{t("probability")}: </strong>
            <span>{formatProbability(85)}</span>
          </Text>
          <Text hasIcon isLoading>
            <strong>{t("Edge")}: </strong>
            {formatProbability(10)}
          </Text>
        </Stack>
      </Stack>
    </Box>
  );
};
